var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-container",
    [
      _c(
        "avue-crud",
        {
          ref: "crud",
          attrs: {
            option: _vm.option,
            "table-loading": _vm.loading,
            data: _vm.data,
            page: _vm.page,
            permission: _vm.permissionList,
            "before-open": _vm.beforeOpen,
          },
          on: {
            "row-update": _vm.rowUpdate,
            "row-save": _vm.rowSave,
            "row-del": _vm.rowDel,
            "search-change": _vm.searchChange,
            "search-reset": _vm.searchReset,
            "selection-change": _vm.selectionChange,
            "current-change": _vm.currentChange,
            "size-change": _vm.sizeChange,
            "refresh-change": _vm.refreshChange,
            "on-load": _vm.onLoad,
          },
          scopedSlots: _vm._u([
            {
              key: "menu",
              fn: function (scope) {
                return [
                  _vm.permissionList.logBtn
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "text",
                            size: "small",
                            icon: "el-icon-view",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleViewLog(scope.row)
                            },
                          },
                        },
                        [_vm._v("日志\n      ")]
                      )
                    : _vm._e(),
                  (scope.row.status == 0 || scope.row.status == 4) &&
                  _vm.permissionList.toExamineBtn
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "text", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.handleToExamine(scope.row, 1)
                            },
                          },
                        },
                        [_vm._v("审核提交\n      ")]
                      )
                    : _vm._e(),
                  scope.row.status == 1 && _vm.permissionList.toExamineBtn
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "text", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.handleToExamine(scope.row, 2)
                            },
                          },
                        },
                        [_vm._v("审核通过\n      ")]
                      )
                    : _vm._e(),
                  scope.row.status == 1 && _vm.permissionList.toExamineBtn
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "text", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.handleToExamine(scope.row, 3)
                            },
                          },
                        },
                        [_vm._v("审核拒绝\n      ")]
                      )
                    : _vm._e(),
                  scope.row.status != 0 &&
                  scope.row.status != 2 &&
                  scope.row.status != 4 &&
                  _vm.permissionList.toExamineBtn
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "text", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.handleToExamine(scope.row, 4)
                            },
                          },
                        },
                        [_vm._v("\n                 审核撤销\n      ")]
                      )
                    : _vm._e(),
                ]
              },
            },
          ]),
          model: {
            value: _vm.form,
            callback: function ($$v) {
              _vm.form = $$v
            },
            expression: "form",
          },
        },
        [
          _c(
            "template",
            { slot: "menuLeft" },
            [
              _vm.permissionList.delBtn
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        size: "small",
                        icon: "el-icon-delete",
                        plain: "",
                      },
                      on: { click: _vm.handleDelete },
                    },
                    [_vm._v("删 除\n      ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "操作日志",
            visible: _vm.logDialogVisible,
            width: "70%",
            "destroy-on-close": true,
            "close-on-click-modal": false,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.logDialogVisible = $event
            },
            closed: _vm.handleLogDialogClosed,
          },
        },
        [
          _c("avue-crud", {
            ref: "LogCrud",
            attrs: {
              option: _vm.logOption,
              "table-loading": _vm.loading,
              data: _vm.Logdata,
              page: _vm.logPage,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }